import WIDGETS from './widgets';

export default {
	name: 'assign_scheduler',
	spacing: 2,
	sx: { width: '100%', margin: '0px' },
	widgets: [{ content: WIDGETS.ASSIGN_SCHEDULER, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
